import { useAuth } from "@clerk/clerk-react";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect, useState } from "react";
import { BannerCouponName, isAdminManagedBannerPromo } from "schemas/dashboard";
import { routes } from "schemas/routes";

import { fetcherAuth } from "utils/api";
import { isPage } from "utils/general";
import { titleCase } from "utils/string";
import { displayLockedCampaignWall } from "utils/time";

import CampaignLockedBanner from "./Promos/CampaignLocked";
import MoneyBackGuaranteePromo from "./Promos/MoneyBackGuranteePromo";
import NewSubscriberPromo from "./Promos/NewSubscriberPromo";
import PastDueBanner from "./Promos/PastDueBanner";
import ProDiscountPriceBanner from "./Promos/ProDiscountPriceBanner";
import SaleBanner from "./Promos/SaleBanner";
import { eligibleForProDiscount } from "./helpers";

const HomeBanner = () => {
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);
  const {
    plans,
    subscription,
    setSubscription,
    setHasPastDue,
    bannerPromoCodes,
  } = useContext(SubscriptionContext);

  const [pastDuePlan, setPastDuePlan] = useState("");
  const [showProDiscount, setShowProDiscount] = useState(false);

  const fetchUser = async () => {
    const res = await fetcherAuth(getToken, `/api/organization/auth/user`);
    setSubscription(res.subscription);
  };

  const fetchPastDuePlan = async () => {
    const res = await fetcherAuth(
      getToken,
      `/api/organization/${currentOrg?.id}/payments/past-due-plan-name`,
    );
    if (res.planName) {
      setPastDuePlan(titleCase(res.planName));
      setHasPastDue(true);
    }
  };

  const hasPromoDate = bannerPromoCodes && bannerPromoCodes.length > 0;
  useEffect(() => {
    if (!hasPromoDate) {
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPromoDate]);

  useEffect(() => {
    if (currentOrg?.id) {
      fetchPastDuePlan();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  useEffect(() => {
    if (eligibleForProDiscount(currentOrg, plans, subscription)) {
      setShowProDiscount(true);
    } else {
      setShowProDiscount(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg, plans, subscription]);

  if (
    isPage(routes.campaignView) &&
    !currentOrg?.isPaidUser &&
    !displayLockedCampaignWall()
  ) {
    return <CampaignLockedBanner />;
  } else if (pastDuePlan) {
    return <PastDueBanner pastDuePlan={pastDuePlan} />;
  }

  const adminManagedPromo = bannerPromoCodes.find(isAdminManagedBannerPromo);
  if (adminManagedPromo) {
    return <SaleBanner promo={adminManagedPromo} />;
  }

  if (showProDiscount) {
    return <ProDiscountPriceBanner />;
  } else if (
    bannerPromoCodes.some(
      (p) => p.couponName === BannerCouponName.money_back_guarantee,
    )
  ) {
    return <MoneyBackGuaranteePromo />;
  } else if (
    bannerPromoCodes.some(
      (p) => p.couponName === BannerCouponName.new_subscriber,
    )
  ) {
    return <NewSubscriberPromo />;
  }
  return <></>;
};

export default HomeBanner;
